import { exportToExcel } from "../utils/exportToExcel";
import { transformPayrollData } from "./helpers/transformPayrollData";

const buildFileName = (data) => {
  const first = data?.[0];
  if (!first?.payrollMonthAbbreviation || !first?.payrollYear) {
    return "Payroll_Report";
  }
  return `Payroll_${first.payrollMonthAbbreviation}${first.payrollYear}`;
};

const buildTitle = (data) => {
  const first = data?.[0];
  if (!first?.payrollMonthFullName || !first?.payrollYear) {
    return null;
  }
  return `Salary Statement For The Month Of ${first.payrollMonthFullName} ${first.payrollYear}`;
};

const ExportPayroll = ({ data }) => {
  const handleDownload = () => {
    const formattedData = transformPayrollData(data);
    const fileName = buildFileName(data);
    const title = buildTitle(data);
    exportToExcel(formattedData, fileName, title);
  };

  return (
    <button
      onClick={handleDownload}
      className="bg-green-600 hover:bg-green-700 disabled:bg-gray-400 disabled:cursor-not-allowed text-white px-6 py-2.5 rounded-lg font-medium transition-colors duration-200 flex items-center gap-2"
    >
      Export Data
    </button>
  );
};

export default ExportPayroll;
